import { capitalize } from 'lodash/fp'

export const cropName = (name: string, isSecond?: boolean) => {
  const [first, second] = capitalize(name).split(' ')
  const get = (n: string) => n.at(0)?.toUpperCase()
  return isSecond && second
    ? `${get(first)}${get(second)}`
    : first.slice(0, isSecond ? 2 : 1)
}
